import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import './main.css';
import { App } from './App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден монтажный узел #root');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
